import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const AdminNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='admin' />

export default AdminNavItem